import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Box
} from '@mui/material';
import { IconX } from '@tabler/icons-react';
import React, { useEffect } from 'react';
import { useSelector } from "react-redux";
import Report from './report';
import FiltersNotAppliedBanner from 'features/globalFilters/FiltersNotAppliedBanner';

const ReportViewerDialog = ({
  open,
  title,
  reportSource,
  category,
  onClose,
  tenantCd
}) => {
  const { currentReport } = useSelector((state) => state.fo);

  const handleClose = () => {
    onClose();
  };

  const onBackButtonEvent = (e) => {
    e.preventDefault();
    onClose();
  };

  const trackViewedReport = () => {
    if (!currentReport) return;
    if (localStorage.getItem('reportHistory')) {
      const reportHistory = JSON.parse(localStorage.getItem('reportHistory')) || {};
      if (tenantCd in reportHistory) {
        const viewedReports = (reportHistory[tenantCd] || []).filter(Boolean);
        reportHistory[tenantCd] = viewedReports;
        if (viewedReports.some(report => report?.luid === currentReport?.luid)) {
          viewedReports.splice(viewedReports.findIndex(report => report?.luid === currentReport?.luid), 1)
          viewedReports.unshift(currentReport);
        } else {
          viewedReports.unshift(currentReport);
          if (viewedReports.length > 10) {
            viewedReports.pop();
          }
        }
        localStorage.setItem('reportHistory', JSON.stringify(reportHistory));
      } else {
        reportHistory[tenantCd] = [ currentReport ];
        localStorage.setItem('reportHistory', JSON.stringify(reportHistory));
      }
    } else {
      localStorage.setItem('reportHistory', JSON.stringify({ [tenantCd]: [ currentReport ] }));
    }
  }

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener('popstate', onBackButtonEvent);
    return () => {
      window.removeEventListener('popstate', onBackButtonEvent);
    };
  }, []);

  useEffect(() => {
    if (currentReport) {
      trackViewedReport();
    }
  }, [currentReport]);

  return (
    <Dialog
      fullScreen
      hideBackdrop
      open={open}
      onClose={(_, reason) => {
        if (reason === 'backdropClick') return;
        handleClose();
      }}
      PaperProps={{
        sx: {
          pointerEvents: 'auto',
          boxShadow: 'none'
        }
      }}
      sx={{
        '& .MuiDialog-paper': {
          top: {
            xs: 'calc(80px + var(--active-filters-banner-height, 0px))',
            md: 'calc(92px + var(--active-filters-banner-height, 0px))',
          },
          boxShadow: 'none'
        },
        pointerEvents: 'none'
      }}
      slotProps={{ 
        backdrop: {
          pointerEvents: 'none'
        }
      }}
      disableEnforceFocus
      disableAutoFocus
    >
      <FiltersNotAppliedBanner />
      <DialogTitle id="reportViewerTitle" sx={{ p: 0, borderTop: '1px solid #959696', '&:not(:first-child)': { borderTop: 'none' } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 3, py: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
              size="large">
              <IconX size={21} color="#000" />
            </IconButton>
            {title}
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent dividers tabIndex={0} sx={{ '&:focus': { outline: 'none' } }}>
        <Report reportSource={reportSource} category={category} />
      </DialogContent>
    </Dialog>
  );
};

export default ReportViewerDialog;
